import React from "react";

export const ForgetPassword = () => <div>forget password</div>;
